import { RouteRecordRaw } from 'vue-router';

export const customizationRoute: RouteRecordRaw = {
  name: 'CustomizationView',
  path: '/customization',
  component: () => import('@/modules/Customization/views/CustomizationView.vue'),
};
